// Copied from dashboard app
import React from 'react';
import { createDate } from '../helpers/dates';

type ButtonProps = {
  dateString?: string;
  dateOnly?: boolean;
};

const DateRender: React.FC<ButtonProps> = ({ dateString, dateOnly }) => {
  if (!dateString) {
    return <></>;
  }
  if (!dateString.endsWith('Z')) {
    dateString = dateString + 'Z';
  }
  const date = createDate(dateString); // Creates a date object in local time

  // Extract local components
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  if (!dateOnly) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
    return <>{formattedDate}</>;
  }

  const formattedDate = `${day}-${month}-${year}`;
  return <>{formattedDate}</>;
};

export default DateRender;
